import { fetch } from '@utils/utils';
import * as T from '@modules/wantedVehicles/_wantedVehiclesTypes';
import { Vehicle } from '@components/vehicle/_vehicleTypes';

// structure of entity after it is created with empty data
export const defaultWantedVehicle = {};

export const getWantedVehicle = ({ addError }) => async (id: string): Promise<T.WantedVehicle> => {
  try {
    const response: any = await fetch(`/metropolis/api/wv/vehicles/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.WantedVehicle = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return defaultWantedVehicle;
  }
};

export const localLookupVehicle = async (vehicle: any): Promise<Array<Vehicle>> => {
  try {
    const response: any = await fetch('/metropolis/api/wv/vehicles/local-lookup', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(vehicle)
    });

    const json = await response.json();

    return json;
  } catch (err) {
    return [];
  }
};

export const externalLookupVehicle = async (vehicle: any): Promise<any> => {
  try {
    const response: any = await fetch('/metropolis/api/wv/vehicles/external-lookup', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(vehicle)
    });

    const json = await response.json();

    return json;
  } catch (err) {
    return null;
  }
};

export const externalLookupIszr = ({ addSuccess, addError }): any => async (vehicle: any): Promise<any> => {
  try {
    const response: any = await fetch('/metropolis/api/wv/vehicles/iszr-lookup', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(vehicle)
    });

    if (response.ok) {
      try {
        const json = await response.json();
        addSuccess('Údaje předvyplneni z PČR');
        return json;
      } catch {
        addError('Nebyl nalezen');
        return null;
      }
    }
    addError('Nastala chyba systému, prosím kontaktujte administrátora.');
    return null;
  } catch (err) {
    addError(err.message);
    return null;
  }
};

export const crvLookupVehicle = async (vehicle: any): Promise<any> => {
  try {
    const response: any = await fetch('/metropolis/api/common/crv/find-vehicle', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(vehicle)
    });

    const json = await response.json();

    if (json.length) {
      return json[0];
    }
    return null;
  } catch (err) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/wantedVehicles/_wantedVehiclesActions.ts